<template>
  <div id="trackinfo">
    <ul class="tabs">
      <li
        v-for="tab in tabs"
        :key="tab.name"
        :class="{ active: currentTab === tab.name }"
        @click="currentTab = tab.name"
        @keyup.enter="currentTab = tab.name"
        @keyup.space="currentTab = tab.name"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot :name="currentTab" />
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentTab: this.tabs.length > 0 ? this.tabs[0].name : null,
    };
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find((t) => t.name === this.currentTab);
      return tab ? tab.component : null;
    },
    currentTabProps() {
      const tab = this.tabs.find((t) => t.name === this.currentTab);
      return tab ? tab.props : {};
    },
  },
};
</script>

<style>
.tabs {
  list-style-type: none;
  padding: 0;
  display: flex;
}

.tabs li {
  padding: 10px 20px;
  cursor: pointer;
  background: #f0f0f0;
  margin-right: 5px;
}

.tabs li.active {
  background: #007bff;
  color: white;
}

.tabs li:focus {
  outline: none;
  box-shadow: 0 0 3px #007bff;
}
</style>
